import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
    countryList: null
};

export const fetchStatelist = createAsyncThunk(
    "fetchStatelist",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/countriesStates/fetch-states-list?page=${body.page}&search=${body.search}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);
export const getAllCountryList = createAsyncThunk(
    "getAllCountryList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/countriesStates/fetch-countries-list?page=${body.page}&search=${body.search}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const StateCountrySlice = createSlice({
    name: "StateCountrySlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchStatelist.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(fetchStatelist.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(fetchStatelist.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(getAllCountryList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getAllCountryList.fulfilled, (state, action) => {
            state.loading = false;
            state.countryList = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(getAllCountryList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default StateCountrySlice.reducer;
